module.exports = __webpack_public_path__ + "static/media/tutorial-completed-popup.aa55cad0.svg";